module.exports = __webpack_public_path__ + "static/media/12_MBTA - Boston.3eab1e2d.jpg";